// teksty: polski zostaje w kodzie jako zapas, angielski przychodzi z window.zpTeksty
function _t(k, d) { var s = window.zpTeksty && window.zpTeksty[k]; return s == null ? d : s; }
/* Zeprado - "Moj rozmiar" (profil rozmiarow). Bez bibliotek zewnetrznych.
 *
 * Co sie zmienilo w tej wersji (ujednolicenie z panelem filtrow):
 *  - profil ma osobne pola: biustonosz (obwod + miseczka), odziez damska,
 *    odziez meska, but; dopasowanie liter idzie po plci PRODUKTU (tag plec:*),
 *  - mozna zapisac DWA profile (np. swoj i partnera) i przelaczac sie miedzy nimi,
 *  - na stronie kolekcji UI nie jest juz osobnym paskiem u gory - rysuje sie
 *    w panelu filtrow (element z data-zp-mr-panel="1"); na karcie produktu
 *    i w wyszukiwarce zostaje pasek jak dotad,
 *  - panel wyboru jest swiadomy kontekstu kolekcji (kolekcja meska nie pokazuje
 *    pol biustonoszowych).
 *
 * Zapis: localStorage['zp_mr_v1'] w formacie v2:
 *   { v:2, filtr:bool, akt:0|1, profile:[{nazwa,dla,obwod,miseczka,ubranie,ubranieM,stopa}],
 *     obwod, miseczka, ubranie, stopa }        <- 4 ostatnie to lustro aktywnego profilu,
 *                                                 zeby stary kod (np. /pages/pomocnik-zakupowy) dalej dzialal.
 * Stary format (plaski obiekt bez "profile") jest wczytywany i migrowany bez utraty danych.
 */
(function () {
  'use strict';
  if (window.__zpMojRozmiar) return;
  window.__zpMojRozmiar = true;

  var KLUCZ = 'zp_mr_v1';
  var CACHE = 'zp_mr_p2:';   /* p2: mini-produkt trzyma teraz takze plec */
  var ROWNOLEGLE = 12;

  /* ---------------------------------------------------------------- slowniki */

  var UBRANIA = ['XS', 'S', 'M', 'L', 'XL', 'XXL', '3XL', '4XL', '5XL', '6XL'];
  var ALIAS = {
    '2XL': 'XXL', 'XXL': 'XXL', 'XXXL': '3XL', '3XXL': '3XL', '4XXL': '4XL',
    'XXXXL': '4XL', '2XS': 'XS', 'XXS': 'XS'
  };
  var MISECZKI = ['AA', 'A', 'B', 'C', 'D', 'E', 'F', 'G', 'H', 'I'];
  var OBWODY = [65, 70, 75, 80, 85, 90, 95, 100, 105, 110];
  var STOPY = [22, 23, 24, 25, 26, 27, 28, 29, 30, 31, 32, 33, 34, 35, 36,
               37, 38, 39, 40, 41, 42, 43, 44, 45, 46, 47];

  /* konfekcja PL -> litera (36 = S, 38 = M, 40 = L, 42 = XL, 44 = XXL) */
  var KONFEKCJA = { 32: 'XS', 34: 'XS', 36: 'S', 38: 'M', 40: 'L', 42: 'XL', 44: 'XXL', 46: '3XL', 48: '4XL', 50: '5XL' };
  /* rozmiary rajstop - odwzorowanie wprost z katalogu sklepu: 2-S, 3-M, 4-L, 5-XL, 6-2XL */
  var RAJSTOPY = { 1: 'XS', 2: 'S', 3: 'M', 4: 'L', 5: 'XL', 6: 'XXL' };

  var TYP_STOPA = { 'Skarpetki': 1, 'Stopki': 1, 'Podkolanówki': 1, 'Zakolanówki': 1, 'Zakostki': 1 };
  var TYP_RAJSTOPY = { 'Rajstopy': 1, 'Pończochy': 1, 'Legginsy': 1 };
  var TYP_MISECZKA = { 'Biustonosze': 1, 'Akcesoria': 1 };
  var UNIWERSALNE = {
    '': 1, 'DEFAULTTITLE': 1, 'ONESIZE': 1, 'UNISIZE': 1,
    'SIZE': 1, 'UNI': 1, 'UNIWERSALNY': 1, 'UNIWERSALNE': 1
  };

  /* --------------------------------------------------------------- profile */

  function pustyProfil(dla) {
    return {
      nazwa: '', dla: dla === 'ktos' ? 'ktos' : 'ja',
      obwod: null, miseczka: null, ubranie: null, ubranieM: null, stopa: null
    };
  }

  function walid(o) {
    o = o || {};
    return {
      nazwa: typeof o.nazwa === 'string' ? o.nazwa.replace(/\s+/g, ' ').trim().slice(0, 24) : '',
      dla: o.dla === 'ktos' ? 'ktos' : 'ja',
      obwod: OBWODY.indexOf(+o.obwod) > -1 ? +o.obwod : null,
      miseczka: MISECZKI.indexOf(o.miseczka) > -1 ? o.miseczka : null,
      ubranie: UBRANIA.indexOf(o.ubranie) > -1 ? o.ubranie : null,
      ubranieM: UBRANIA.indexOf(o.ubranieM) > -1 ? o.ubranieM : null,
      stopa: STOPY.indexOf(+o.stopa) > -1 ? +o.stopa : null
    };
  }

  function surowy() {
    try { return JSON.parse(localStorage.getItem(KLUCZ) || '{}') || {}; } catch (e) { return {}; }
  }

  function wczytaj() {
    var s = surowy(), lista = [], i;
    if (Object.prototype.toString.call(s.profile) === '[object Array]') {
      for (i = 0; i < s.profile.length && lista.length < 2; i++) lista.push(walid(s.profile[i]));
    }
    if (!lista.length) {
      /* stary format: jedno pole "ubranie" bylo bezplciowe - przepisujemy je na oba,
         zeby nikomu nie zniknely dotychczasowe dopasowania */
      lista = [walid({ obwod: s.obwod, miseczka: s.miseczka, ubranie: s.ubranie, ubranieM: s.ubranie, stopa: s.stopa })];
    }
    return { filtr: !!s.filtr, akt: (+s.akt === 1 && lista.length > 1) ? 1 : 0, profile: lista };
  }

  var stan = wczytaj();

  function aktywny() { return stan.profile[stan.akt] || stan.profile[0]; }

  function zapisz() {
    var a = aktywny();
    var dane = {
      v: 2, filtr: stan.filtr, akt: stan.akt, profile: stan.profile,
      obwod: a.obwod, miseczka: a.miseczka, ubranie: a.ubranie || a.ubranieM, stopa: a.stopa
    };
    try { localStorage.setItem(KLUCZ, JSON.stringify(dane)); } catch (e) { /* tryb prywatny */ }
  }

  /** Ktos (np. /pages/pomocnik-zakupowy) zapisal w starym formacie - wpisujemy w aktywny profil,
   *  zamiast kasowac drugi profil. */
  function odswiezZePamieci() {
    var s = surowy();
    if (s.profile) { stan = wczytaj(); return; }
    var a = aktywny();
    var n = walid({ obwod: s.obwod, miseczka: s.miseczka, ubranie: s.ubranie, ubranieM: s.ubranie, stopa: s.stopa });
    a.obwod = n.obwod; a.miseczka = n.miseczka; a.ubranie = n.ubranie;
    if (n.ubranieM) a.ubranieM = n.ubranieM;
    a.stopa = n.stopa;
    stan.filtr = !!s.filtr;
    zapisz();
  }

  function nazwaProfilu(p, i) {
    if (p.nazwa) return p.nazwa;
    if (p.dla === 'ktos') return 'Druga osoba';
    return i === 1 ? _t('mr_profil2', 'Profil 2') : 'Ja';
  }

  function biust(p) { p = p || aktywny(); return (p.obwod && p.miseczka) ? (p.obwod + p.miseczka) : null; }
  function cokolwiek(p) { p = p || aktywny(); return !!(biust(p) || p.ubranie || p.ubranieM || p.stopa); }
  function token() {
    var p = aktywny();
    return [stan.akt, biust(p), p.ubranie, p.ubranieM, p.stopa].join('|');
  }

  /* ------------------------------------------------------------- kontekst */
  /* plec: 'm' (kolekcja meska) | 'd' (damska) | 'x' (mieszana/nieznana) */

  var kontekst = { plec: 'x' };

  function ustawKontekst(k) {
    if (!k || !k.plec || kontekst.plec === k.plec) return;
    if (k.plec !== 'm' && k.plec !== 'd' && k.plec !== 'x') return;
    kontekst.plec = k.plec;
    rysujWszystkieUI();
  }

  /* --------------------------------------- rozpoznawanie rozmiaru wariantu */

  function rangaUbrania(t) {
    var s = ALIAS[t] || t;
    var i = UBRANIA.indexOf(s);
    return i > -1 ? i : null;
  }

  function zakresUbran(a, b) {
    var r = [], i, t;
    if (a > b) { t = a; a = b; b = t; }
    for (i = a; i <= b; i++) r.push({ k: 'ubranie', r: i });
    return r;
  }

  /* zwraca: {k:'biust',o,m} {k:'ubranie',r} {k:'stopa',a,b} {k:'miseczka',m} {k:'uni'} */
  function rozpoznaj(surowyR, typ) {
    var s = String(surowyR == null ? '' : surowyR).trim().toUpperCase().replace(/\s+/g, '');
    if (UNIWERSALNE[s] === 1) return [{ k: 'uni' }];
    var m, a, b, lista, rr;

    m = s.match(/^(\d{2,3})(AA|BB|CC|DD|[A-I])$/);
    if (m && +m[1] >= 60 && +m[1] <= 125 && +m[1] % 5 === 0) return [{ k: 'biust', o: +m[1], m: m[2] }];

    m = s.match(/^(\d{2,3})(AA|BB|CC|DD|[A-I])[-\/](XS|S|M|L|XL|XXL|2XL|3XL|4XL|5XL)$/);
    if (m && +m[1] % 5 === 0) {
      lista = [{ k: 'biust', o: +m[1], m: m[2] }];
      rr = rangaUbrania(m[3]);
      if (rr !== null) lista.push({ k: 'ubranie', r: rr });
      return lista;
    }

    rr = rangaUbrania(s);
    if (rr !== null) return [{ k: 'ubranie', r: rr }];

    m = s.match(/^([1-6])[-\/](XS|S|M|L|XL|XXL|2XL|3XL)$/);
    if (m) { a = rangaUbrania(m[2]); if (a !== null) return [{ k: 'ubranie', r: a }]; }

    m = s.match(/^(XS|S|M|L|XL|XXL|2XL|3XL|4XL|5XL)[-\/](XS|S|M|L|XL|XXL|2XL|3XL|4XL|5XL)$/);
    if (m) {
      a = rangaUbrania(m[1]); b = rangaUbrania(m[2]);
      if (a !== null && b !== null) return zakresUbran(a, b);
    }

    m = s.match(/^(\d{2})[-\/](\d{2})$/);
    if (m) {
      a = +m[1]; b = +m[2];
      if (a > b) { rr = a; a = b; b = rr; }
      if (a >= 18 && b <= 52) {
        if (TYP_STOPA[typ] === 1) return [{ k: 'stopa', a: a, b: b }];
        if (KONFEKCJA[a] && KONFEKCJA[b]) {
          var ra = rangaUbrania(KONFEKCJA[a]), rb = rangaUbrania(KONFEKCJA[b]);
          if (ra !== null && rb !== null) return zakresUbran(ra, rb);
        }
        return [{ k: 'stopa', a: a, b: b }];
      }
      return [];
    }

    m = s.match(/^([1-6])[-\/]([1-6])$/);
    if (m && TYP_RAJSTOPY[typ] === 1) {
      a = rangaUbrania(RAJSTOPY[+m[1]]); b = rangaUbrania(RAJSTOPY[+m[2]]);
      if (a !== null && b !== null) return zakresUbran(a, b);
    }

    m = s.match(/^(\d{1,3})$/);
    if (m) {
      var n = +m[1];
      if (TYP_STOPA[typ] === 1 && n >= 18 && n <= 52) return [{ k: 'stopa', a: n, b: n }];
      if (TYP_RAJSTOPY[typ] === 1 && RAJSTOPY[n]) {
        a = rangaUbrania(RAJSTOPY[n]);
        if (a !== null) return [{ k: 'ubranie', r: a }];
      }
      if (KONFEKCJA[n] && n % 2 === 0) {
        a = rangaUbrania(KONFEKCJA[n]);
        if (a !== null) return [{ k: 'ubranie', r: a }];
      }
      return [];
    }

    if (TYP_MISECZKA[typ] === 1) {
      m = s.match(/^(AA|BB|CC|[A-I])$/);
      if (m) return [{ k: 'miseczka', m: m[1] }];
      m = s.match(/^(AA|BB|CC|[A-I])[-\/](AA|BB|CC|[A-I])$/);
      if (m) return [{ k: 'miseczka', m: m[1] }, { k: 'miseczka', m: m[2] }];
    }

    return [];
  }

  /** Plec produktu z tagow sklepu. '' = brak jednoznacznej informacji. */
  function plecZTagow(tagi) {
    if (!tagi || !tagi.length) return '';
    var m = 0, d = 0, i, t;
    for (i = 0; i < tagi.length; i++) {
      t = String(tagi[i]).toLowerCase();
      if (t === 'plec:meskie') m = 1;
      else if (t === 'plec:damskie') d = 1;
    }
    if (m && !d) return 'm';
    if (d && !m) return 'd';
    return '';
  }

  /** Rozmiar odziezy z profilu wlasciwy dla plci produktu ('' = obojetna). */
  function ubranieDlaPlci(plec, p) {
    p = p || aktywny();
    if (plec === 'm') return p.ubranieM;
    if (plec === 'd') return p.ubranie;
    return null;   /* obojetna plec obslugiwana osobno w pasuje() */
  }

  function pasuje(tok, plec) {
    var p = aktywny();
    if (tok.k === 'biust') return !!biust(p) && tok.o === p.obwod && tok.m === p.miseczka;
    if (tok.k === 'miseczka') return !!p.miseczka && tok.m === p.miseczka;
    if (tok.k === 'stopa') return !!p.stopa && p.stopa >= tok.a && p.stopa <= tok.b;
    if (tok.k === 'ubranie') {
      if (plec === 'm' || plec === 'd') {
        var u = ubranieDlaPlci(plec, p);
        return !!u && tok.r === rangaUbrania(u);
      }
      return (!!p.ubranie && tok.r === rangaUbrania(p.ubranie)) ||
             (!!p.ubranieM && tok.r === rangaUbrania(p.ubranieM));
    }
    return false;
  }

  function mamWymiar(k, plec) {
    var p = aktywny();
    if (k === 'biust') return !!biust(p);
    if (k === 'miseczka') return !!p.miseczka;
    if (k === 'stopa') return !!p.stopa;
    if (k === 'ubranie') {
      if (plec === 'm') return !!p.ubranieM;
      if (plec === 'd') return !!p.ubranie;
      return !!(p.ubranie || p.ubranieM);
    }
    return false;
  }

  /* --------------------------------------- ocena produktu z /products/x.js */

  function warianty(prod) {
    var idx = 0, i, nazwa;
    if (prod.options && prod.options.length) {
      for (i = 0; i < prod.options.length; i++) {
        nazwa = prod.options[i] && prod.options[i].name ? prod.options[i].name : prod.options[i];
        if (String(nazwa).toLowerCase().indexOf('rozmiar') > -1) { idx = i; break; }
      }
    }
    return (prod.variants || []).map(function (v) {
      var wart = (v.options && v.options[idx] != null) ? v.options[idx] : v.option1;
      return { r: wart, dost: !!v.available, id: v.id };
    });
  }

  /* 'tak' | 'nie' | 'uni' | 'brak' */
  function ocen(prod) {
    var w = warianty(prod), i, j, toks;
    var plec = prod.plec != null ? prod.plec : plecZTagow(prod.tags);
    var wymiary = {}, uni = false, znane = false, k;
    for (i = 0; i < w.length; i++) {
      toks = rozpoznaj(w[i].r, prod.type);
      for (j = 0; j < toks.length; j++) {
        if (toks[j].k === 'uni') { uni = true; continue; }
        znane = true;
        wymiary[toks[j].k] = 1;
        if (w[i].dost && pasuje(toks[j], plec)) return 'tak';
      }
    }
    if (!znane) return uni ? 'uni' : 'brak';
    for (k in wymiary) if (mamWymiar(k, plec)) return 'nie';
    return 'brak';
  }

  /* --------------------------------------------------------- pobieranie */

  var pamiec = {};

  function zCache(handle) {
    if (pamiec[handle]) return pamiec[handle];
    try {
      var s = sessionStorage.getItem(CACHE + handle);
      if (s) { pamiec[handle] = JSON.parse(s); return pamiec[handle]; }
    } catch (e) { /* brak sessionStorage */ }
    return null;
  }

  function doCache(handle, mini) {
    pamiec[handle] = mini;
    try { sessionStorage.setItem(CACHE + handle, JSON.stringify(mini)); } catch (e) { /* limit */ }
  }

  var kolejka = [], biegnie = 0, wDrodze = {};

  /* jeden produkt = jedno zapytanie, nawet gdy poprosi o niego kilka kart naraz */
  function pobierz(handle, gotowe) {
    var c = zCache(handle);
    if (c) { gotowe(c); return; }
    if (wDrodze[handle]) { wDrodze[handle].push(gotowe); return; }
    wDrodze[handle] = [gotowe];
    kolejka.push(handle);
    pompuj();
  }

  function rozdaj(handle, mini) {
    var cb = wDrodze[handle] || [];
    delete wDrodze[handle];
    for (var i = 0; i < cb.length; i++) {
      try { cb[i](mini); } catch (e) { /* nic */ }
    }
  }

  function pompuj() {
    while (biegnie < ROWNOLEGLE && kolejka.length) {
      biegnie++;
      (function (handle) {
        fetch('/products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (p) {
            var mini = null, w, i;
            if (p) {
              mini = { t: p.type || '', g: plecZTagow(p.tags), v: [] };
              w = warianty(p);
              for (i = 0; i < w.length; i++) mini.v.push([w[i].r, w[i].dost ? 1 : 0, w[i].id]);
              doCache(handle, mini);
            }
            biegnie--;
            rozdaj(handle, mini);
            pompuj();
          })
          .catch(function () { biegnie--; rozdaj(handle, null); pompuj(); });
      })(kolejka.shift());
    }
  }

  function zMini(mini) {
    return {
      type: mini.t,
      plec: mini.g || '',
      options: [{ name: _t('mr_rozmiar', 'Rozmiar') }],
      variants: mini.v.map(function (x) {
        return { options: [x[0]], option1: x[0], available: !!x[1], id: x[2] };
      })
    };
  }

  /* ------------------------------------------------- rozmiary siostrzane */

  function siostry(o, mm) {
    var i = MISECZKI.indexOf(mm), lista = [];
    if (i < 0) return lista;
    if (MISECZKI[i + 1] && OBWODY.indexOf(o - 5) > -1) lista.push((o - 5) + MISECZKI[i + 1]);
    if (i > 0 && MISECZKI[i - 1] && OBWODY.indexOf(o + 5) > -1) lista.push((o + 5) + MISECZKI[i - 1]);
    return lista;
  }

  function sasiedzi(u) {
    var i = rangaUbrania(u), lista = [];
    if (i === null) return lista;
    if (i > 0 && UBRANIA[i - 1]) lista.push(UBRANIA[i - 1]);
    if (UBRANIA[i + 1]) lista.push(UBRANIA[i + 1]);
    return lista;
  }

  /* ------------------------------------------------------------- pomoce */

  function el(tag, klasa, tekst) {
    var e = document.createElement(tag);
    if (klasa) e.className = klasa;
    if (tekst != null) e.textContent = tekst;
    return e;
  }

  /** Opis profilu. Domyslnie tylko to, co ma znaczenie na tej stronie
   *  (kolekcja meska nie wypisuje biustonosza, damska - odziezy meskiej). */
  function opisProfilu(p, wszystko) {
    p = p || aktywny();
    var plec = wszystko ? 'x' : kontekst.plec;
    var cz = [];
    if (biust(p) && plec !== 'm') cz.push('biustonosz ' + biust(p));
    if (p.ubranie && plec !== 'm') cz.push('odzież ' + (plec === 'x' ? 'damska ' : '') + p.ubranie);
    if (p.ubranieM && plec !== 'd') cz.push('odzież męska ' + p.ubranieM);
    if (p.stopa) cz.push('but ' + p.stopa);
    if (!cz.length && !wszystko) return opisProfilu(p, true);   /* nic z kontekstu - pokaz, co jest */
    return cz.join(' · ');
  }

  /* ------------------------------------------------------- panel wyboru */

  var panel = null;

  function chipy(rodzic, wartosci, biezaca, wybierz) {
    var box = el('div', 'zp-mr-chipy');
    wartosci.forEach(function (w) {
      var b = el('button', 'zp-mr-chip', String(w));
      b.type = 'button';
      if (biezaca != null && String(w) === String(biezaca)) b.setAttribute('aria-pressed', 'true');
      b.addEventListener('click', function () {
        var teraz = b.getAttribute('aria-pressed') === 'true';
        wybierz(teraz ? null : w);
      });
      box.appendChild(b);
    });
    rodzic.appendChild(box);
    return box;
  }

  function otworz() {
    if (!panel) {
      panel = document.createElement('dialog');
      panel.className = 'zp-mr-panel';
      panel.setAttribute('aria-label', _t('mr_twoj_rozmiar', 'Twój rozmiar'));
      document.body.appendChild(panel);
      panel.addEventListener('click', function (e) { if (e.target === panel) zamknij(); });
    }

    /* kopia robocza: profile edytujemy dopiero po _t('mr_zapisz_krotko', "Zapisz") */
    var robocze = stan.profile.map(function (p) { return walid(p); });
    var ktory = stan.akt < robocze.length ? stan.akt : 0;
    var pokazWszystko = false;

    panel.textContent = '';
    var top = el('div', 'zp-mr-panel__top');
    top.appendChild(el('h2', 'zp-mr-panel__tytul', _t('mr_twoj_rozmiar', 'Twój rozmiar')));
    var x = el('button', 'zp-mr-x', '×');
    x.type = 'button';
    x.setAttribute('aria-label', 'Zamknij');
    x.addEventListener('click', zamknij);
    top.appendChild(x);
    panel.appendChild(top);

    panel.appendChild(el('p', 'zp-mr-panel__lead',
      'Wypełnij tylko to, czego używasz. Zapamiętamy profil w tej przeglądarce i oznaczymy na listach produkty dostępne w Twoim rozmiarze.'));

    var zakladki = el('div', 'zp-mr-zakladki');
    panel.appendChild(zakladki);

    var tresc = el('div', 'zp-mr-panel__tresc');
    panel.appendChild(tresc);

    var stopka = el('div', 'zp-mr-panel__stopka');
    var czysc = el('button', 'zp-mr-btn zp-mr-btn--pusty', _t('mr_wyczysc_profil', 'Wyczyść ten profil'));
    czysc.type = 'button';
    czysc.addEventListener('click', function () {
      var d = robocze[ktory].dla, n = robocze[ktory].nazwa;
      robocze[ktory] = pustyProfil(d);
      robocze[ktory].nazwa = n;
      rysujTresc();
    });
    var zap = el('button', 'zp-mr-btn zp-mr-btn--glowny', _t('mr_zapisz_rozmiar', 'Zapisz rozmiar'));
    zap.type = 'button';
    zap.addEventListener('click', function () {
      stan.profile = robocze.filter(function (p, i) { return i === 0 || cokolwiek(p) || p.nazwa; });
      if (!stan.profile.length) stan.profile = [pustyProfil('ja')];
      stan.akt = ktory < stan.profile.length ? ktory : 0;
      if (!cokolwiek()) stan.filtr = false;
      zapisz();
      zamknij();
      poZmianie();
    });
    stopka.appendChild(czysc);
    stopka.appendChild(zap);
    panel.appendChild(stopka);

    function rysujZakladki() {
      zakladki.textContent = '';
      if (robocze.length === 1 && !cokolwiek(robocze[0])) return;   /* pierwszy raz: bez zamieszania */
      robocze.forEach(function (p, i) {
        var b = el('button', 'zp-mr-zakladka', nazwaProfilu(p, i));
        b.type = 'button';
        if (i === ktory) b.setAttribute('aria-pressed', 'true');
        b.addEventListener('click', function () { ktory = i; rysujTresc(); });
        zakladki.appendChild(b);
      });
      if (robocze.length < 2) {
        var d = el('button', 'zp-mr-zakladka zp-mr-zakladka--dodaj', '+ Drugi profil');
        d.type = 'button';
        d.addEventListener('click', function () {
          robocze.push(pustyProfil('ktos'));
          ktory = robocze.length - 1;
          rysujTresc();
        });
        zakladki.appendChild(d);
      }
    }

    function grupaBiust(p) {
      var g = el('section', 'zp-mr-grupa');
      g.appendChild(el('h3', 'zp-mr-grupa__tyt', 'Biustonosz'));
      g.appendChild(el('span', 'zp-mr-grupa__pod', _t('mr_obwod', 'Obwód pod biustem')));
      chipy(g, OBWODY, p.obwod, function (v) { p.obwod = v; rysujTresc(); });
      g.appendChild(el('span', 'zp-mr-grupa__pod', 'Miseczka'));
      chipy(g, MISECZKI, p.miseczka, function (v) { p.miseczka = v; rysujTresc(); });
      return g;
    }

    function grupaUbranie(p) {
      var g = el('section', 'zp-mr-grupa');
      g.appendChild(el('h3', 'zp-mr-grupa__tyt', _t('mr_damska', 'Odzież i bielizna damska')));
      chipy(g, UBRANIA, p.ubranie, function (v) { p.ubranie = v; rysujTresc(); });
      g.appendChild(el('p', 'zp-mr-grupa__info',
        'Rozmiary liczbowe przeliczamy wg konfekcji: 36 = S, 38 = M, 40 = L, 42 = XL, 44 = XXL.'));
      return g;
    }

    function grupaUbranieM(p) {
      var g = el('section', 'zp-mr-grupa');
      g.appendChild(el('h3', 'zp-mr-grupa__tyt', _t('mr_meska', 'Odzież i bielizna męska')));
      chipy(g, UBRANIA, p.ubranieM, function (v) { p.ubranieM = v; rysujTresc(); });
      g.appendChild(el('p', 'zp-mr-grupa__info',
        _t('mr_meskie_info', 'Bokserki, slipy, kalesony i piżamy męskie są zwykle w rozmiarach S–3XL.')));
      return g;
    }

    function grupaStopa(p) {
      var g = el('section', 'zp-mr-grupa');
      g.appendChild(el('h3', 'zp-mr-grupa__tyt', _t('mr_buty', 'Buty (skarpetki, stopki, podkolanówki)')));
      g.appendChild(el('span', 'zp-mr-grupa__pod', _t('mr_rozmiar_buta', 'Rozmiar buta')));
      chipy(g, STOPY, p.stopa, function (v) { p.stopa = v; rysujTresc(); });
      return g;
    }

    function rysujTresc() {
      rysujZakladki();
      tresc.textContent = '';
      var p = robocze[ktory];

      /* dla kogo kupuje */
      var dla = el('div', 'zp-mr-dla');
      dla.appendChild(el('span', 'zp-mr-dla__etyk', _t('mr_kupuje_dla', 'Kupuję dla:')));
      [['ja', 'siebie'], ['ktos', _t('mr_ktos_inny', 'kogoś innego')]].forEach(function (o) {
        var b = el('button', 'zp-mr-chip', o[1]);
        b.type = 'button';
        if (p.dla === o[0]) b.setAttribute('aria-pressed', 'true');
        b.addEventListener('click', function () { p.dla = o[0]; rysujTresc(); });
        dla.appendChild(b);
      });
      tresc.appendChild(dla);

      if (robocze.length > 1) {
        var nz = el('div', 'zp-mr-nazwa');
        var lab = el('label', 'zp-mr-nazwa__etyk', 'Nazwa profilu');
        var inp = document.createElement('input');
        inp.type = 'text';
        inp.className = 'zp-mr-nazwa__pole';
        inp.maxLength = 24;
        inp.value = p.nazwa;
        inp.placeholder = nazwaProfilu(p, ktory);
        inp.addEventListener('input', function () { p.nazwa = inp.value.slice(0, 24); });
        inp.addEventListener('change', rysujZakladki);
        lab.setAttribute('for', 'zp-mr-nazwa-pole');
        inp.id = 'zp-mr-nazwa-pole';
        nz.appendChild(lab);
        nz.appendChild(inp);
        tresc.appendChild(nz);
      }

      var widoczne, ukryte;
      if (kontekst.plec === 'm') {
        widoczne = [grupaUbranieM, grupaStopa];
        ukryte = [grupaUbranie, grupaBiust];
      } else if (kontekst.plec === 'd') {
        widoczne = [grupaBiust, grupaUbranie, grupaStopa];
        ukryte = [grupaUbranieM];
      } else {
        widoczne = [grupaBiust, grupaUbranie, grupaUbranieM, grupaStopa];
        ukryte = [];
      }
      widoczne.forEach(function (f) { tresc.appendChild(f(p)); });
      if (ukryte.length) {
        if (pokazWszystko) {
          ukryte.forEach(function (f) { tresc.appendChild(f(p)); });
        } else {
          var wiecej = el('button', 'zp-mr-link', _t('mr_pokaz_pola', 'Pokaż pozostałe pola profilu'));
          wiecej.type = 'button';
          wiecej.addEventListener('click', function () { pokazWszystko = true; rysujTresc(); });
          tresc.appendChild(wiecej);
        }
      }
    }

    rysujTresc();
    if (typeof panel.showModal === 'function') panel.showModal();
    else panel.setAttribute('open', '');
  }

  function zamknij() {
    if (!panel) return;
    if (typeof panel.close === 'function' && panel.open) panel.close();
    else panel.removeAttribute('open');
  }

  function poZmianie() {
    zapomnijKarty();
    rysujWszystkieUI();
    przelicz(true);
    odswiezKarteProduktu();
    try { document.dispatchEvent(new CustomEvent('zp:rozmiar-zmiana')); } catch (e) { /* stare przegladarki */ }
  }

  /* ----------------------------------------------- UI: pasek albo w panelu */

  function przelacznikFiltra(klasa) {
    var f = el('button', 'zp-mr-btn zp-mr-btn--filtr' + (klasa ? ' ' + klasa : ''), 'Pokaż tylko mój rozmiar');
    f.type = 'button';
    f.setAttribute('aria-pressed', stan.filtr ? 'true' : 'false');
    f.addEventListener('click', function () {
      stan.filtr = !stan.filtr;
      zapisz();
      przelicz(true);
    });
    return f;
  }

  function przelacznikOsob(box) {
    if (stan.profile.length < 2) return;
    var os = el('div', 'zp-mr-osoby');
    stan.profile.forEach(function (p, i) {
      var b = el('button', 'zp-mr-osoba', nazwaProfilu(p, i));
      b.type = 'button';
      if (i === stan.akt) b.setAttribute('aria-pressed', 'true');
      b.addEventListener('click', function () {
        if (stan.akt === i) return;
        stan.akt = i;
        zapisz();
        poZmianie();
      });
      os.appendChild(b);
    });
    box.appendChild(os);
  }

  /** Blok w panelu filtrow (jedno miejsce na rozmiar na stronie kolekcji). */
  function rysujBlok(root) {
    root.textContent = '';
    var box = el('div', 'zp-mr-blok');
    var gora = el('div', 'zp-mr-blok__gora');
    gora.appendChild(el('span', 'zp-mr-blok__tyt', _t('mr_twoj_rozmiar', 'Twój rozmiar')));
    if (cokolwiek()) {
      var zm = el('button', 'zp-mr-link', _t('mr_zmien', 'Zmień'));
      zm.type = 'button';
      zm.addEventListener('click', otworz);
      gora.appendChild(zm);
    }
    box.appendChild(gora);

    przelacznikOsob(box);

    if (cokolwiek()) {
      box.appendChild(el('p', 'zp-mr-blok__plakietka', opisProfilu()));
      box.appendChild(przelacznikFiltra());
      var licz = el('span', 'zp-mr-licznik');
      licz.setAttribute('data-zp-mr-licznik', '1');
      box.appendChild(licz);
    } else {
      box.appendChild(el('p', 'zp-mr-blok__lead',
        _t('mr_zapisz_info', 'Zapisz rozmiar, a oznaczymy produkty dostępne właśnie dla Ciebie.')));
      var z = el('button', 'zp-mr-btn zp-mr-btn--glowny', _t('mr_zapisz', 'Zapisz swój rozmiar'));
      z.type = 'button';
      z.addEventListener('click', otworz);
      box.appendChild(z);
    }
    root.appendChild(box);
  }

  /** Pasek (karta produktu, wyszukiwarka) - jak dotad. */
  function rysujPasek(root) {
    root.textContent = '';
    var lista = root.getAttribute('data-zp-mr-lista') === '1';
    var box = el('div', 'zp-mr-pasek');

    var lewa = el('div', 'zp-mr-pasek__lewa');
    var ikona = el('span', 'zp-mr-ikona');
    ikona.setAttribute('aria-hidden', 'true');
    lewa.appendChild(ikona);

    var t = el('span', 'zp-mr-pasek__tekst');
    if (cokolwiek()) {
      t.appendChild(el('strong', null, _t('mr_twoj_rozmiar_dw', 'Twój rozmiar: ')));
      t.appendChild(document.createTextNode(opisProfilu()));
    } else {
      t.textContent = _t('mr_ustaw', 'Ustaw swój rozmiar — pokażemy, co jest dostępne właśnie dla Ciebie.');
    }
    lewa.appendChild(t);
    box.appendChild(lewa);

    var prawa = el('div', 'zp-mr-pasek__prawa');
    if (stan.profile.length > 1) przelacznikOsob(prawa);

    if (cokolwiek() && lista) {
      prawa.appendChild(przelacznikFiltra());
      var licz = el('span', 'zp-mr-licznik');
      licz.setAttribute('data-zp-mr-licznik', '1');
      prawa.appendChild(licz);
    }

    var z = el('button', 'zp-mr-btn zp-mr-btn--pusty', cokolwiek() ? _t('mr_zmien', 'Zmień') : 'Wybierz rozmiar');
    z.type = 'button';
    z.addEventListener('click', otworz);
    prawa.appendChild(z);

    box.appendChild(prawa);
    root.appendChild(box);
  }

  function rysujWszystkieUI() {
    Array.prototype.forEach.call(document.querySelectorAll('[data-zp-mr-root]'), function (root) {
      if (root.getAttribute('data-zp-mr-panel') === '1') rysujBlok(root);
      else rysujPasek(root);
    });
    zadbajOSkrot();
    zadbajOPigulke();
  }

  /* skrot na pasku _t('mr_filtruj', "Filtruj") (telefon): ten sam panel wyboru, nie drugie pole */
  function zadbajOSkrot() {
    var cel = document.querySelector('[data-zp-mr-skrot]');
    if (!cel) return;
    cel.textContent = '';
    var b = el('button', 'zp-f__otworz zp-mr-skrot');
    b.type = 'button';
    b.appendChild(el('span', null, cokolwiek() ? ('Rozmiar: ' + (biust() || aktywny().ubranie || aktywny().ubranieM || aktywny().stopa)) : _t('mr_twoj_rozmiar', 'Twój rozmiar')));
    b.addEventListener('click', otworz);
    cel.appendChild(b);
  }

  /* Pigulka przy dolnej krawedzi - widoczna, gdy blok/pasek nie jest na ekranie.
     Liczymy z prostokata elementu, a nie IntersectionObserverem: na telefonie blok
     siedzi w panelu filtrow (position: fixed), wiec jego prostokat nie zmienia sie
     przy przewijaniu i obserwator nigdy by sie nie odezwal. */

  var pigulka = null, sluchaczePigulki = false;

  function pigulkaWidok() {
    if (!pigulka) return;
    var root = document.querySelector('[data-zp-mr-root][data-zp-mr-lista="1"]');
    if (!root) { pigulka.hidden = true; return; }
    var r = root.getBoundingClientRect();
    var h = window.innerHeight || document.documentElement.clientHeight;
    var widacRoot = r.height > 0 && r.bottom > 0 && r.top < h;
    var przewinieto = (window.pageYOffset || document.documentElement.scrollTop || 0) > 300;
    pigulka.hidden = widacRoot || !przewinieto;
  }

  function zadbajOPigulke() {
    var root = document.querySelector('[data-zp-mr-root][data-zp-mr-lista="1"]');
    if (!root || !cokolwiek() || !siatki().length) {
      if (pigulka) { pigulka.remove(); pigulka = null; }
      return;
    }
    if (!pigulka) {
      pigulka = el('div', 'zp-mr-pigulka');
      var b = el('button', null);
      b.type = 'button';
      var licz = el('span', 'zp-mr-licznik');
      licz.setAttribute('data-zp-mr-licznik', '1');
      b.appendChild(el('span', null, 'Tylko mój rozmiar'));
      b.appendChild(licz);
      b.addEventListener('click', function () {
        stan.filtr = !stan.filtr;
        zapisz();
        przelicz(true);
      });
      pigulka.appendChild(b);
      document.body.appendChild(pigulka);
    }
    pigulka.firstChild.setAttribute('aria-pressed', stan.filtr ? 'true' : 'false');
    if (!sluchaczePigulki) {
      sluchaczePigulki = true;
      var czeka = false;
      /* zwykly timer, nie requestAnimationFrame - rAF stoi w karcie w tle */
      var odswiez = function () {
        if (czeka) return;
        czeka = true;
        setTimeout(function () { czeka = false; pigulkaWidok(); }, 100);
      };
      window.addEventListener('scroll', odswiez, { passive: true });
      window.addEventListener('resize', odswiez);
    }
    pigulkaWidok();
  }

  /* ------------------------------------------------------------- karty */

  function siatki() {
    return Array.prototype.slice.call(
      document.querySelectorAll('ul[data-testid="product-grid"], ul.product-grid'));
  }

  function handleZKarty(karta) {
    var a = karta.querySelector('a[href*="/products/"]');
    if (!a) return null;
    var h = (a.getAttribute('href') || '').split('?')[0].split('#')[0];
    var i = h.indexOf('/products/');
    if (i < 0) return null;
    h = h.slice(i + 10).split('/')[0];
    return h || null;
  }

  function kotwica(karta) {
    return karta.querySelector('.card-gallery') || karta;
  }

  function oznacz(karta, stanK) {
    karta.setAttribute('data-zp-mr', stanK);
    var stara = karta.querySelector('.zp-mr-plakietka');
    if (stanK !== 'tak') { if (stara) stara.remove(); return; }
    if (stara) return;
    var k = kotwica(karta);
    if (window.getComputedStyle(k).position === 'static') k.style.position = 'relative';
    k.appendChild(el('span', 'zp-mr-plakietka', 'Jest w Twoim rozmiarze'));
  }

  function ukryj(karta, czyUkryc) {
    var poj = karta.closest('li') || karta;
    if (czyUkryc) {
      if (poj.getAttribute('data-zp-mr-ukryte') !== '1') {
        poj.setAttribute('data-zp-mr-ukryte', '1');
        poj.style.display = 'none';
      }
    } else if (poj.getAttribute('data-zp-mr-ukryte') === '1') {
      poj.removeAttribute('data-zp-mr-ukryte');
      poj.style.display = '';
    }
  }

  /* gdy filtr schowa wszystko - wyjasnienie zamiast pustej strony */
  function pustaSiatka(siatka, razem, widac) {
    var stary = siatka.parentNode ? siatka.parentNode.querySelector('.zp-mr-pusto') : null;
    var trzeba = stan.filtr && cokolwiek() && razem > 0 && widac === 0;
    if (!trzeba) { if (stary) stary.remove(); return; }
    if (stary) return;
    var box = el('div', 'zp-mr-pusto');
    box.appendChild(el('strong', null, 'Na tej stronie nie ma nic w Twoim rozmiarze.'));
    box.appendChild(el('span', null, _t('mr_ukrylismy', 'Ukryliśmy wszystkie ') + razem + _t('mr_produktow_wylacz', ' produktów. Wyłącz filtr albo zajrzyj na kolejną stronę listy.')));
    var b = el('button', 'zp-mr-btn zp-mr-btn--glowny', _t('mr_pokaz_wszystkie', 'Pokaż wszystkie'));
    b.type = 'button';
    b.addEventListener('click', function () {
      stan.filtr = false;
      zapisz();
      przelicz(true);
    });
    box.appendChild(b);
    siatka.parentNode.insertBefore(box, siatka.nextSibling);
  }

  function policz() {
    var widac = 0, razem = 0;
    siatki().forEach(function (s) {
      var w = 0, r = 0;
      Array.prototype.forEach.call(s.querySelectorAll('product-card'), function (k) {
        r++;
        if ((k.closest('li') || k).getAttribute('data-zp-mr-ukryte') !== '1') w++;
      });
      widac += w; razem += r;
      pustaSiatka(s, r, w);
    });
    Array.prototype.forEach.call(document.querySelectorAll('[data-zp-mr-licznik]'), function (e) {
      e.textContent = razem ? ('widzisz ' + widac + ' z ' + razem) : '';
    });
  }

  function zapomnijKarty() {
    Array.prototype.forEach.call(document.querySelectorAll('product-card[data-zp-mr-t]'), function (k) {
      k.removeAttribute('data-zp-mr-t');
    });
  }

  var wTrakcie = false;

  function zastosuj(karta, stanK) {
    wTrakcie = true;
    oznacz(karta, stanK);
    ukryj(karta, !!(stan.filtr && cokolwiek() && stanK === 'nie'));
    wTrakcie = false;
  }

  function przelicz(przerysuj) {
    if (przerysuj) rysujWszystkieUI();
    var tk = token();
    var karty = Array.prototype.slice.call(document.querySelectorAll('product-card'));
    if (!karty.length) { policz(); return; }

    karty.forEach(function (karta) {
      if (!cokolwiek()) { zastosuj(karta, 'brak'); return; }
      var h = handleZKarty(karta);
      if (!h) { zastosuj(karta, 'brak'); return; }
      if (karta.getAttribute('data-zp-mr-t') === tk && karta.getAttribute('data-zp-mr')) {
        zastosuj(karta, karta.getAttribute('data-zp-mr'));
        return;
      }
      pobierz(h, function (mini) {
        var st = mini ? ocen(zMini(mini)) : 'brak';
        karta.setAttribute('data-zp-mr-t', tk);
        zastosuj(karta, st);
        policz();
      });
    });
    policz();
  }

  /* --------------------------------------------------- karta produktu */

  function pickerRozmiaru() {
    var vp = document.querySelector('variant-picker');
    if (!vp) return null;
    var lista = [];
    Array.prototype.forEach.call(vp.querySelectorAll('input[type="radio"][data-option-name]'), function (i) {
      if (String(i.getAttribute('data-option-name') || '').toLowerCase().indexOf('rozmiar') > -1) lista.push(i);
    });
    if (!lista.length) return null;
    return { picker: vp, wejscia: lista, fieldset: lista[0].closest('fieldset') || vp };
  }

  function wybierzRozmiar(wejscia, wartosc) {
    for (var i = 0; i < wejscia.length; i++) {
      if (String(wejscia[i].value).trim().toUpperCase() === String(wartosc).trim().toUpperCase()) {
        if (!wejscia[i].checked) wejscia[i].click();
        return true;
      }
    }
    return false;
  }

  function odswiezKarteProduktu() {
    var stary = document.querySelector('.zp-mr-komunikat');
    if (stary) stary.remove();
    komunikatProduktu();
  }

  function komunikatProduktu() {
    var p = pickerRozmiaru();
    if (!p || !cokolwiek()) return;
    if (document.querySelector('.zp-mr-komunikat')) return;
    var handle = p.picker.getAttribute('data-product-handle');
    if (!handle) {
      var mm = location.pathname.match(/\/products\/([^\/?#]+)/);
      handle = mm ? mm[1] : null;
    }
    if (!handle) return;

    pobierz(handle, function (mini) {
      if (!mini) return;
      var p2 = pickerRozmiaru();
      if (!p2 || document.querySelector('.zp-mr-komunikat')) return;
      var prod = zMini(mini), w = warianty(prod), plec = prod.plec;
      var prof = aktywny();
      /* karta produktu zna plec wprost - ustawiamy kontekst panelu wyboru */
      if (plec === 'm' || plec === 'd') ustawKontekst({ plec: plec });
      var trafiony = null, wyprzedany = null, wymiary = {};

      w.forEach(function (v) {
        rozpoznaj(v.r, prod.type).forEach(function (t) {
          if (t.k === 'uni') return;
          wymiary[t.k] = 1;
          if (!pasuje(t, plec)) return;
          if (v.dost) { if (!trafiony) trafiony = v.r; }
          else if (!wyprzedany) wyprzedany = v.r;
        });
      });

      var mojeUbranie = plec === 'm' ? prof.ubranieM : (plec === 'd' ? prof.ubranie : (prof.ubranie || prof.ubranieM));
      var wym = null;
      if (wymiary.biust && biust(prof)) wym = 'biust';
      else if (wymiary.ubranie && mojeUbranie) wym = 'ubranie';
      else if (wymiary.stopa && prof.stopa) wym = 'stopa';
      else if (wymiary.miseczka && prof.miseczka) wym = 'miseczka';
      if (!wym) return;

      var opis = wym === 'biust' ? biust(prof)
        : wym === 'ubranie' ? mojeUbranie
        : wym === 'stopa' ? String(prof.stopa) : prof.miseczka;

      var box = el('div', 'zp-mr-komunikat');

      if (trafiony) {
        box.className = 'zp-mr-komunikat zp-mr-komunikat--ok';
        var udalo = wybierzRozmiar(p2.wejscia, trafiony);
        box.appendChild(el('strong', null, _t('mr_twoj_rozmiar_sp', 'Twój rozmiar ') + opis + _t('mr_jest_dostepny', ' jest dostępny.')));
        box.appendChild(document.createTextNode(
          udalo ? _t('mr_zaznaczylismy', ' Zaznaczyliśmy go za Ciebie.') : _t('mr_zaznacz', ' Zaznacz go na liście powyżej.')));
      } else {
        box.className = 'zp-mr-komunikat zp-mr-komunikat--brak';
        box.appendChild(el('strong', null, 'Rozmiaru ' + opis + ' nie ma w tym modelu.'));
        if (wyprzedany) {
          box.appendChild(el('span', 'zp-mr-komunikat__etyk',
            'Rozmiar ' + wyprzedany + ' jest w ofercie, ale chwilowo wyprzedany.'));
        }

        var propozycje = wym === 'biust' ? siostry(prof.obwod, prof.miseczka)
          : wym === 'ubranie' ? sasiedzi(mojeUbranie) : [];

        if (propozycje.length) {
          var dostepne = {};
          w.forEach(function (v) { if (v.dost) dostepne[String(v.r).trim().toUpperCase()] = v.r; });
          box.appendChild(el('span', 'zp-mr-komunikat__etyk',
            wym === 'biust' ? _t('mr_siostrzane', 'Rozmiary siostrzane:') : _t('mr_sasiednie', 'Sąsiednie rozmiary:')));
          var rzad = el('div', 'zp-mr-siostry'), jest = false;
          propozycje.forEach(function (r) {
            var K = String(r).toUpperCase(), ma = !!dostepne[K];
            if (ma) jest = true;
            var b = el('button', 'zp-mr-siostra' + (ma ? '' : ' zp-mr-siostra--brak'),
              r + (ma ? ' · na stanie' : ' · niedostępny'));
            b.type = 'button';
            b.disabled = !ma;
            if (ma) b.addEventListener('click', function () { wybierzRozmiar(p2.wejscia, dostepne[K]); });
            rzad.appendChild(b);
          });
          box.appendChild(rzad);
          if (!jest) {
            box.appendChild(el('span', 'zp-mr-komunikat__etyk',
              _t('mr_brak_stanu', 'Żaden z nich nie jest w tej chwili na stanie.')));
          }
        }
      }

      var zmien = el('button', 'zp-mr-link', _t('mr_zmien_moj', 'Zmień mój rozmiar'));
      zmien.type = 'button';
      zmien.addEventListener('click', otworz);
      box.appendChild(zmien);

      p2.fieldset.parentNode.insertBefore(box, p2.fieldset.nextSibling);
    });
  }

  /* ------------------------------------------------------------- start */

  var rafId = null;

  function pozniej() {
    if (wTrakcie) return;
    if (rafId) return;
    rafId = requestAnimationFrame(function () {
      rafId = null;
      przelicz(false);
      komunikatProduktu();
    });
  }

  function start() {
    if (!document.querySelector('[data-zp-mr-root]')) return;
    rysujWszystkieUI();
    przelicz(false);
    komunikatProduktu();

    var obs = new MutationObserver(function (m) {
      for (var i = 0; i < m.length; i++) {
        var t = m[i].target;
        if (t && t.closest && t.closest('[data-zp-mr-root], .zp-mr-panel, .zp-mr-pasek, .zp-mr-blok, .zp-mr-komunikat, .zp-mr-plakietka, .zp-f__pasek, .zp-f__body, .zp-f__stopka')) continue;
        pozniej();
        return;
      }
    });
    obs.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () {
      setTimeout(function () { rysujWszystkieUI(); przelicz(false); }, 60);
    });
    window.addEventListener('pageshow', function () {
      stan = wczytaj(); zapomnijKarty(); przelicz(true);
    });
    window.addEventListener('storage', function (e) {
      if (e.key === KLUCZ) { odswiezZePamieci(); zapomnijKarty(); rysujWszystkieUI(); przelicz(true); odswiezKarteProduktu(); }
    });
    /* zp-pomocnik-most: pomocnik zakupowy (/pages/pomocnik-zakupowy) zapisuje rozmiar i daje znac zdarzeniem */
    document.addEventListener('zp:rozmiar', function () {
      odswiezZePamieci();
      zapomnijKarty();
      rysujWszystkieUI();
      przelicz(true);
      odswiezKarteProduktu();
    });
  }

  /* male API do diagnostyki, testow i wspolpracy z panelem filtrow */
  window.zpMojRozmiar = {
    rozpoznaj: rozpoznaj,
    ocen: ocen,
    profil: function () { return aktywny(); },
    profile: function () { return stan.profile; },
    stanZapisu: function () { return stan; },
    kontekst: function () { return kontekst; },
    ustawKontekst: ustawKontekst,
    /** Co podswietlic w grupach filtra rozmiaru (nie zaznaczamy nic na sile). */
    doFiltrow: function () {
      var p = aktywny();
      var u = kontekst.plec === 'm' ? p.ubranieM : (kontekst.plec === 'd' ? p.ubranie : (p.ubranie || p.ubranieM));
      return {
        jest: cokolwiek(p), plec: kontekst.plec, filtr: stan.filtr,
        obwod: p.obwod, miseczka: p.miseczka, ubranie: u, stopa: p.stopa,
        opis: opisProfilu(p), nazwa: nazwaProfilu(p, stan.akt)
      };
    },
    ustaw: function (o) {
      var p = aktywny();
      p.obwod = OBWODY.indexOf(+o.obwod) > -1 ? +o.obwod : null;
      p.miseczka = MISECZKI.indexOf(o.miseczka) > -1 ? o.miseczka : null;
      p.ubranie = UBRANIA.indexOf(o.ubranie) > -1 ? o.ubranie : null;
      p.ubranieM = UBRANIA.indexOf(o.ubranieM) > -1 ? o.ubranieM : null;
      p.stopa = STOPY.indexOf(+o.stopa) > -1 ? +o.stopa : null;
      if (o.dla) p.dla = o.dla === 'ktos' ? 'ktos' : 'ja';
      if (o.nazwa != null) p.nazwa = String(o.nazwa).slice(0, 24);
      if (o.filtr != null) stan.filtr = !!o.filtr;
      zapisz();
      poZmianie();
      return aktywny();
    },
    dodajProfil: function (o) {
      if (stan.profile.length > 1) return null;
      stan.profile.push(walid(o || { dla: 'ktos' }));
      stan.akt = 1;
      zapisz();
      poZmianie();
      return aktywny();
    },
    przelaczProfil: function (i) {
      i = +i === 1 ? 1 : 0;
      if (!stan.profile[i]) return null;
      stan.akt = i;
      zapisz();
      poZmianie();
      return aktywny();
    },
    otworz: otworz,
    przelicz: function () { zapomnijKarty(); przelicz(true); },
    stany: function () {
      var r = { tak: 0, nie: 0, uni: 0, brak: 0, razem: 0, widac: 0 };
      siatki().forEach(function (s) {
        Array.prototype.forEach.call(s.querySelectorAll('product-card'), function (k) {
          r.razem++;
          var st = k.getAttribute('data-zp-mr') || 'brak';
          if (r[st] != null) r[st]++;
          if ((k.closest('li') || k).getAttribute('data-zp-mr-ukryte') !== '1') r.widac++;
        });
      });
      return r;
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
